// extracted by mini-css-extract-plugin
export default {"actionBtn":"MyProject_actionBtn__XNpEB","projectTitleImage":"MyProject_projectTitleImage__cC2ul"};